import "core-js/modules/es.array.push.js";
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue";
import { RouterView, useRouter, useRoute } from "vue-router";
import { ref, watch, onMounted } from "vue";
import { storehouseId } from "./assets/js/store";
import autoUpdate from "@/assets/js/auto-update";
export default {
  __name: 'App',
  setup(__props) {
    let router = useRouter();
    const route = useRoute();
    const transitionName = ref("push");
    const cachedViews = ref([]);
    const keyFresh = ref(0);
    router.beforeEach((to, from) => {
      // 总后台用户信息进入店铺列表销毁keep-alive 实现刷新效果
      if (from.name == 'userInfo' && to.name == 'adminShopList') {
        keyFresh.value++;
      }
      // 店铺后台信息进入商品列表销毁keep-alive 实现刷新效果
      if (from.name == 'adminStoreInfo' && to.name == 'commodWareh') {
        storehouseId.value = 0;
        keyFresh.value++;
      }
      // 根据路由标记判断触发哪个动画
      if (to.meta.index > from.meta.index) {
        transitionName.value = "push"; // 向左滑动
      } else if (to.meta.index < from.meta.index) {
        // 由次级到主级
        transitionName.value = "back";
      } else {
        transitionName.value = ""; // 同级无过渡效果
      }
    });

    const updateCachedViews = (e1, e2) => {
      if (route.meta && route.meta.keepAlive) {
        if (!cachedViews.value.includes(route.name)) {
          cachedViews.value.push(route.name);
        }
      } else {
        cachedViews.value = cachedViews.value.filter(view => view !== route.name);
      }
      console.log(cachedViews.value, '******');
      autoUpdate.start(); // 检查更新
    };

    watch(route, updateCachedViews);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(RouterView), {
        key: keyFresh.value
      }, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: transitionName.value
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
            include: cachedViews.value
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))]),
          _: 2
        }, 1032, ["name"])]),
        _: 1
      });
    };
  }
};